export const CONSTANT_ACCOUNT_CLOSURE = {
    GET_STATUS_THEME: (status: string): string => {
        status = `${status}`.toLowerCase()
        if (status.includes("failed")) {
            return "slds-theme--error"
        }
        if (status.includes("limit")) {
            return  "slds-theme_warning"
        }
        if (status === "closed") {
            return  "slds-theme--success"
        }
        if (status === "expired" || status.includes("cancel")) {
            return "slds-theme_warning"
        }
        return "slds-progress-bar__value"
    },
}

export const CONSTANT_STACKSETS_DRIFTS = {
    GET_STATUS_THEME: (status: string): string => {
        status = `${status}`.toLowerCase()
        if (status.includes("drifted")) {
            return "slds-theme--error"
        }
        if (status === "not checked") {
            return  "slds-theme--success"
        }
        return "slds-progress-bar__value"
    },
}

export const CONSTANT_GENERIC_DEPLOYMENTS = {
    GET_STATUS_THEME: (status: string, isBadge = false): string => {
        status = `${status}`.toLowerCase()
        if (status.includes("failed") || status.includes("error")) {
            return "slds-theme--error"
        }
        if (status.includes("succe") || status.includes("complete")) {
            return  "slds-theme--success"
        }
        if (status.includes("processing") || status.includes("going") || status.includes("progress") || status.includes("reverted")) {
            return  "slds-theme_warning"
        }
        return isBadge ? "" : "slds-progress-bar__value"
    },
}